import { Fragment } from 'react';
import { Formprops } from './Changepassword.types';
import Spinner from '../../../components/Spinner/Spinner';
import PasswordInput from '../../../components/Form/PasswordInput';

const Changepasswordform = ({ register, formState: { errors, isSubmitting } }: Formprops) => {
  return (
    <Fragment>
      <p className="form-support">Para proteger este cambio, verifica primero un código vigente de Microsoft Authenticator.</p>
      <label className="form-label" htmlFor="totpCode">Código de Microsoft Authenticator</label>
      <input
        className={`form-input${errors.totpCode ? ' form-input-invalid' : ''}`}
        id="totpCode"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        aria-invalid={Boolean(errors.totpCode)}
        {...register('totpCode', { required: { value: true, message: 'Ingresa el código vigente de Microsoft Authenticator' }, pattern: { value: /^\d{6}$/, message: 'Debe tener 6 dígitos' } })}
      />
      <p className="form-input-error-message">{errors.totpCode?.message}</p>
      <label className="form-label" htmlFor="password">
        Nueva contraseña
      </label>
      <PasswordInput
        className={`form-input${errors.password ? ' form-input-invalid' : ''}`}
        id="password"
        autoComplete="new-password"
        aria-invalid={Boolean(errors.password)}
        aria-describedby={errors.password ? 'change-password-error' : undefined}
        {...register('password', { required: { value: true, message: 'Este campo es requerido' } })}
      />
      <p className="form-input-error-message" id="change-password-error">{errors.password?.message}</p>
      <button className="form-button" type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
        {isSubmitting ? <><Spinner label="Actualizando contraseña" /><span>Actualizando…</span></> : 'Cambiar contraseña'}
      </button>
    </Fragment>
  );
};

export default Changepasswordform;
